import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { DialogContentText, DialogTitle } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';

export default function DialogVoucher({
  modalBody,
  modalTitle,
  open,
  handleClose,
  handleDone
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{modalTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{modalBody}</DialogContentText>
      </DialogContent>
      <DialogActions style={{ textAlign: 'center' }}>
        <Button onClick={handleClose} color="primary" variant="contained">
          {t('voucher_applications_modalNo')}
        </Button>
        <Button
          onClick={() => {
            handleDone();
          }}
          color="secondary"
          variant="contained"
        >
          {t('voucher_applications_modalYes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
